import axios from '../../utils/axiosConfig';

export const HELP_SEND_REQUEST = 'HELP_SEND_REQUEST';
export const HELP_SEND_SUCCESS = 'HELP_SEND_SUCCESS';
export const HELP_SEND_FAIL = 'HELP_SEND_FAIL';
export const HELP_CLEAR_STATUS = 'HELP_CLEAR_STATUS';

// NEW (Guest Contact Us)
export const GUEST_HELP_SEND_REQUEST = 'GUEST_HELP_SEND_REQUEST';
export const GUEST_HELP_SEND_SUCCESS = 'GUEST_HELP_SEND_SUCCESS';
export const GUEST_HELP_SEND_FAIL = 'GUEST_HELP_SEND_FAIL';
export const GUEST_HELP_CLEAR_STATUS = 'GUEST_HELP_CLEAR_STATUS';

export const sendHelpMessage =
  ({ topic, message }) =>
  async (dispatch) => {
    try {
      dispatch({ type: HELP_SEND_REQUEST });

      const payload = {
        topic: String(topic || '').trim(),
        message: String(message || '').trim(),
      };

      await axios.post('/help', payload);

      dispatch({ type: HELP_SEND_SUCCESS });
    } catch (err) {
      dispatch({
        type: HELP_SEND_FAIL,
        payload: err?.response?.data?.message || 'Failed to send help message.',
      });
    }
  };

// NEW: Guest contact us (no auth)
export const sendGuestHelpMessage =
  ({ name, email, phone, message, website }) =>
  async (dispatch) => {
    try {
      dispatch({ type: GUEST_HELP_SEND_REQUEST });

      const payload = {
        name: String(name || '').trim(),
        email: String(email || '').trim(),
        phone: phone ? String(phone).trim() : null,
        message: String(message || '').trim(),
        // honeypot (optional; should be empty)
        website: website ? String(website).trim() : '',
      };

      // backend route example: POST /help/guest
      await axios.post('/help/guest', payload);

      dispatch({ type: GUEST_HELP_SEND_SUCCESS });
    } catch (err) {
      dispatch({
        type: GUEST_HELP_SEND_FAIL,
        payload:
          err?.response?.data?.message || 'Failed to send contact message.',
      });
    }
  };

export const clearHelpStatus = () => ({ type: HELP_CLEAR_STATUS });

// NEW: clear guest status
export const clearGuestHelpStatus = () => ({ type: GUEST_HELP_CLEAR_STATUS });
